const r = {
  // All starhub domains
  "http://localhost:3006": { carrier: "starhub", type: "device_protection", env: "local" },
  // For local Portal
  "http://localhost:3106": { carrier: "starhub", type: "device_protection", env: "local" },
  // For local Shared
  "https://seahzn-myasurion2-dev.apac.nonprod-asurion53.com": {
    carrier: "starhub",
    type: "device_protection",
    env: "dev"
  },
  "https://seahzn-myasurion2-sqa.apac.nonprod-asurion53.com": {
    carrier: "starhub",
    type: "device_protection",
    env: "sqa"
  },
  "https://seahzn-myasurion2-uat.apac.asurion53.com": {
    carrier: "starhub",
    type: "device_protection",
    env: "uat"
  },
  "https://starhub-sqa.myasurion2.apac.nonprod-asurion53.com": {
    carrier: "starhub",
    type: "device_protection",
    env: "sqa",
    isDemo: !0
  },
  "https://starhub-uat.myasurion2.apac.asurion53.com": {
    carrier: "starhub",
    type: "device_protection",
    env: "uat",
    isDemo: !0
  },
  // All tom (asurion_techcare) domains
  "http://localhost:6006": {
    carrier: "asurion_techcare",
    type: "device_protection",
    env: "local"
  },
  // For local Portal dp
  "http://localhost:6007": { carrier: "asurion_techcare", type: "repair", env: "local" },
  // For local Portal repair
  "http://localhost:6106": {
    carrier: "asurion_techcare",
    type: "device_protection",
    env: "local"
  },
  // For local shared dp
  "http://localhost:6107": {
    carrier: "asurion_techcare",
    type: "repair",
    env: "local"
  },
  // For local shared repair
  "https://tom-myasurion-dev.apac.nonprod-asurion53.com": {
    carrier: "asurion_techcare",
    type: "device_protection",
    env: "dev"
  },
  "https://tom-myasurion-sqa.apac.nonprod-asurion53.com": {
    carrier: "asurion_techcare",
    type: "device_protection",
    env: "sqa"
  },
  "https://tom-myasurion-uat.apac.asurion53.com": {
    carrier: "asurion_techcare",
    type: "device_protection",
    env: "uat"
  },
  "https://tom-repair-myasurion-dev.apac.nonprod-asurion53.com": {
    carrier: "asurion_techcare",
    type: "repair",
    env: "dev"
  },
  "https://tom-repair-myasurion-sqa.apac.nonprod-asurion53.com": {
    carrier: "asurion_techcare",
    type: "repair",
    env: "sqa"
  },
  "https://tom-repair-myasurion-uat.apac.asurion53.com": {
    carrier: "asurion_techcare",
    type: "repair",
    env: "uat"
  },
  "https://my.asurion.co.th": {
    carrier: "asurion_techcare",
    type: "device_protection",
    env: "prod"
  },
  "https://my-techcare.apac.asurion53.com": {
    carrier: "asurion_techcare",
    type: "device_protection",
    env: "prod"
  },
  "https://my-repair.asurion.co.th": {
    carrier: "asurion_techcare",
    type: "repair",
    env: "prod"
  },
  "https://my-repair-techcare.apac.asurion53.com": {
    carrier: "asurion_techcare",
    type: "repair",
    env: "prod"
  },
  "https://techcare-sqa.myasurion2.apac.nonprod-asurion53.com": {
    carrier: "asurion_techcare",
    type: "device_protection",
    env: "sqa",
    isDemo: !0
  },
  "https://techcare-uat.myasurion2.apac.asurion53.com": {
    carrier: "asurion_techcare",
    type: "device_protection",
    env: "uat",
    isDemo: !0
  },
  // All maxis domains
  "http://localhost:3016": { carrier: "maxis", type: "device_protection", env: "local" },
  // For local Portal dp
  "http://localhost:3017": { carrier: "maxis", type: "repair", env: "local" },
  // For local Portal repair
  "http://localhost:3116": { carrier: "maxis", type: "device_protection", env: "local" },
  // For local shared dp
  "http://localhost:3117": { carrier: "maxis", type: "repair", env: "local" },
  // For local shared repair
  "https://maxis-uat.myasurion2.apac.asurion53.com": {
    carrier: "maxis",
    type: "device_protection",
    env: "uat",
    isDemo: !0
  },
  "https://maxis-myasurion-dev.apac.nonprod-asurion53.com": {
    carrier: "maxis",
    type: "device_protection",
    env: "dev"
  },
  "https://maxis-myasurion-sqa.apac.nonprod-asurion53.com": {
    carrier: "maxis",
    type: "device_protection",
    env: "sqa"
  },
  "https://maxis-myasurion-uat.apac.asurion53.com": {
    carrier: "maxis",
    type: "device_protection",
    env: "uat"
  },
  "https://maxis-repair-myasurion-dev.apac.nonprod-asurion53.com": {
    carrier: "maxis",
    type: "repair",
    env: "dev"
  },
  "https://maxis-repair-myasurion-sqa.apac.nonprod-asurion53.com": {
    carrier: "maxis",
    type: "repair",
    env: "sqa"
  },
  "https://maxis-repair-myasurion-uat.apac.asurion53.com": {
    carrier: "maxis",
    type: "repair",
    env: "uat"
  },
  "http://localhost:4006": { carrier: "asurion", type: "device_protection", env: "local" },
  "http://localhost:5006": { carrier: "true", type: "device_protection", env: "local" },
  "http://localhost:7006": { carrier: "celcom", type: "device_protection", env: "local" },
  "http://localhost:8006": { carrier: "umobile", type: "device_protection", env: "local" },
  "http://localhost:9006": { carrier: "lazada", type: "device_protection", env: "local" },
  "http://localhost:4106": { carrier: "asurion", type: "device_protection", env: "local" },
  "http://localhost:5106": { carrier: "true", type: "device_protection", env: "local" },
  "http://localhost:7106": { carrier: "celcom", type: "device_protection", env: "local" },
  "http://localhost:8106": { carrier: "umobile", type: "device_protection", env: "local" },
  "http://localhost:9106": { carrier: "lazada", type: "device_protection", env: "local" },
  "http://localhost:9506": { carrier: "demo1", type: "device_protection", env: "local" },
  "http://localhost:9606": { carrier: "demo1", type: "device_protection", env: "local" },
  "http://localhost:7117": {
    carrier: "twopenmarket_synnex",
    type: "device_protection",
    env: "local"
  },
  "http://localhost:7118": {
    carrier: "twopenmarket_synnex",
    type: "device_protection",
    env: "local"
  },
  "https://asurion-sqa.myasurion2.apac.nonprod-asurion53.com": {
    carrier: "asurion",
    type: "device_protection",
    env: "sqa"
  },
  "https://true-sqa.myasurion2.apac.nonprod-asurion53.com": {
    carrier: "true",
    type: "device_protection",
    env: "sqa"
  },
  "https://celcom-sqa.myasurion2.apac.nonprod-asurion53.com": {
    carrier: "celcom",
    type: "device_protection",
    env: "sqa"
  },
  "https://umobile-sqa.myasurion2.apac.nonprod-asurion53.com": {
    carrier: "umobile",
    type: "device_protection",
    env: "sqa"
  },
  "https://lazada-th-sqa.myasurion2.apac.nonprod-asurion53.com": {
    carrier: "lazada",
    type: "device_protection",
    env: "sqa"
  },
  "https://true-uat.myasurion2.apac.asurion53.com": {
    carrier: "true",
    type: "device_protection",
    env: "uat"
  },
  "https://asurion-uat.myasurion2.apac.asurion53.com": {
    carrier: "asurion",
    type: "device_protection",
    env: "uat"
  },
  "https://celcom-uat.myasurion2.apac.asurion53.com": {
    carrier: "celcom",
    type: "device_protection",
    env: "uat"
  },
  "https://umobile-uat.myasurion2.apac.asurion53.com": {
    carrier: "umobile",
    type: "device_protection",
    env: "uat"
  },
  "https://lazada-th-uat.myasurion2.apac.asurion53.com": {
    carrier: "lazada",
    type: "device_protection",
    env: "uat"
  },
  "https://demo1.myasurion2.apac.asurion53.com": {
    carrier: "demo1",
    type: "device_protection",
    env: "uat"
  },
  "https://synnex-ews-myasurion-dev.apac.nonprod-asurion53.com": {
    carrier: "twopenmarket_synnex",
    type: "device_protection",
    env: "dev"
  },
  "https://synnex-ews-myasurion-sqa.apac.nonprod-asurion53.com": {
    carrier: "twopenmarket_synnex",
    type: "device_protection",
    env: "sqa"
  },
  "https://synnex-ews-myasurion-uat.apac.asurion53.com": {
    carrier: "twopenmarket_synnex",
    type: "device_protection",
    env: "uat"
  },
  "https://sinya.asurion.com.tw": {
    carrier: "twopenmarket_synnex",
    type: "device_protection",
    env: "prod"
  },
  "https://sinya-green.apac.asurion53.com": {
    carrier: "twopenmarket_synnex",
    type: "device_protection",
    env: "prod"
  }
}, i = () => {
  var e;
  return ((e = r[window.location.origin]) == null ? void 0 : e.carrier) || "asurion";
}, n = () => {
  var e;
  return ((e = r[window.location.origin]) == null ? void 0 : e.type) || "device_protection";
}, p = (e, o, c) => {
  var t;
  for (const a in r)
    if (r[a].carrier === e && r[a].type === o && r[a].env === c && ((t = r[a]) == null ? void 0 : t.isDemo) === void 0)
      return a;
};
export {
  n as a,
  p as b,
  i as g
};
